import React from "react";

const CaseWorkspaceCompliancePanelHelp = () => (
  <div>
    <p>
      Use Run validation after correcting participant, action plan or intervention information.
      Resolve blocking issues before preparing an ILMP export, and review any warnings.
    </p>
    <p>
      For clients awaiting submission, the result matches the Participant submission queue.
      You can also check current reportable information when nothing is awaiting submission.
      This does not change or requeue a submitted report.
    </p>
    <p>
      Draft plans are excluded. Nothing to validate means there are no reportable plans to check.
      A validation result does not confirm that ESDC accepted a previous submission.
    </p>
    <p>
      Select an issue summary to read the full details. Finance status is separate from ILMP validation.
    </p>
  </div>
);

CaseWorkspaceCompliancePanelHelp.aiContext = `Run validation checks current reportable ILMP information. When reports are queued, its result matches the Participant submission queue. Without queued reports, it can check current reportable information read-only, including submitted or accepted plans, without changing saved reports or requeuing them. Draft plans are excluded. Nothing to validate means no reportable plans exist. A check does not certify historical XML or ESDC acceptance. Select an issue summary for details. Finance status is separate.`;

export default CaseWorkspaceCompliancePanelHelp;
